import React, { useEffect, useRef, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bubble } from "react-chartjs-2";
import Export from "../../assets/dashboard/export.svg";
import tabImg from "../../assets/dashboard/tabImg.svg";
import close from "../../assets/draft/close.svg";
import preview from "../../assets/draft/preview.png";
import visit from "../../assets/dashboard/visit.svg";
import globe from "../../assets/posts/globe.svg";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
  Legend
);

const TopPost = () => {
  const [activeTab, setActiveTab] = useState("Top content");
  const containerRef = useRef(null);

  const tabs = [
    { label: "Top content", icon: tabImg },
    { label: "Trending", icon: tabImg },
  ];

  const data = {
    datasets: [
      {
        label: "Higher engagement",
        data: Array.from({ length: 25 }, () => ({
          x: Math.floor(Math.random() * 200 - 100),
          y: Math.floor(Math.random() * 200 - 100),
          r: Math.floor(Math.random() * 15 + 5),
        })),
        backgroundColor: "#fdd835",
      },
      {
        label: "Lower engagement",
        data: Array.from({ length: 25 }, () => ({
          x: Math.floor(Math.random() * 200 - 100),
          y: Math.floor(Math.random() * 200 - 100),
          r: Math.floor(Math.random() * 15 + 5),
        })),
        backgroundColor: "#55dde0",
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      tooltip: {
        enabled: false,
        external: (context) => {
          // Create tooltip element if it doesn't exist
          let tooltipEl =
            containerRef.current?.querySelector("#toppost-tooltip");

          if (!tooltipEl && containerRef.current) {
            tooltipEl = document.createElement("div");
            tooltipEl.id = "toppost-tooltip";
            tooltipEl.className = "absolute z-50 pointer-events-none";
            containerRef.current.appendChild(tooltipEl);
          }

          if (!tooltipEl) return;

          const { tooltip } = context;

          // Hide
          if (!tooltip || tooltip.opacity === 0) {
            tooltipEl.style.opacity = 0;
            return;
          }

          // Build content
          const title = "Preview Top Post";
          const dateLabel = new Date().toLocaleString("en-US", {
            month: "short",
            day: "2-digit",
          });

          const body =
            "Exciting news! Next Thursday I'm hosting a live webinar on AI-powered user research—covering auto-tagging interviews, sentiment maps, and ethical guardr...";

          const likes = 25;
          const comments = 15;
          const reposts = 4;

          tooltipEl.innerHTML = `
            <div class="shadow-md bg-white rounded-xl border border-black-40 w-[400px]">
              <div class="flex items-center justify-between px-4 py-2 border-b border-black-40">
                <div class="flex items-center gap-2">
                  <span class="inline-block w-6 h-6 rounded bg-yellow-400"></span>
                  <span class="font-bold text-black-800 text-lg">${title}</span>
                </div>
                <div class="flex space-x-2">
                <div class="text-black-80 text-sm">${dateLabel}</div>
                <img 
                    src="${close}" 
                    alt="Preview" 
                  />
                </div>
              </div>

              <div class="p-4">
                <div class="flex gap-3">
                  <div class="w-20 h-20 rounded-md bg-gray-100 flex items-center justify-center text-black-400 text-xs"> <img 
                    src="${preview}" 
                    alt="Preview" 
                    class="w-20 h-20 rounded-md object-contain border border-black-500" 
                  /></div>
                  <div class="flex-1">
                    <div class="text-sm text-black-800 leading-snug">
                      ${body}
                    </div>
                    <div class="mt-2 text-xs text-black-400 flex">1d · Edited ·  <img 
                    src="${globe}" 
                    alt="Preview" 
                    class="ml-1"
                  /></div>
                  </div>
                </div>

                <div class="mt-3 flex items-center justify-between text-xs text-black-800">
                  <span>${likes} Likes</span>
                  <span>${comments} Comments, ${reposts} Reposts</span>
                </div>

                <div class="mt-3 flex justify-end">
                  <button class="px-3 py-1.5 text-lg text-black-800 font-bold rounded border-2 border-black-600 hover:bg-black-0 flex items-center justify-center space-x-2">Visit post <img 
                    src="${visit}" 
                    alt="Preview" 
                    class="w-6 h-2"
                  /></button>
                </div>
              </div>
            </div>`;

          const { caretX, caretY } = tooltip;
          const parentRect = containerRef.current?.getBoundingClientRect();
          const canvasRect = context.chart.canvas.getBoundingClientRect();

          // Position relative to container
          const left =
            caretX + (canvasRect.left - (parentRect?.left || 0)) + 12;
          const top = caretY + (canvasRect.top - (parentRect?.top || 0)) - 20;

          tooltipEl.style.opacity = 1;
          tooltipEl.style.left = `${left}px`;
          tooltipEl.style.top = `${top}px`;
        },
      },
      legend: {
        position: "bottom",
        align: "start",
        labels: {
          usePointStyle: true,
          boxWidth: 12,
        },
      },
    },
    scales: {
      x: {
        min: -100,
        max: 100,
        grid: {
          color: "#e5e5e5",
        },
      },
      y: {
        min: -100,
        max: 100,
        grid: {
          color: "#e5e5e5",
        },
      },
    },
  };

  useEffect(() => {
    // Cleanup tooltip on unmount
    return () => {
      const el = containerRef.current?.querySelector("#toppost-tooltip");
      if (el && el.parentNode) el.parentNode.removeChild(el);
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className="relative border border-gradient-04 rounded-2xl p-2 md:p-4 shadow-sm bg-white"
    >
      {/* Header */}
      <div className="flex justify-between items-center mb-4 border-b border-black-40">
        <h2 className="font-bold text-lg text-black-800 uppercase">
          Top Posts
        </h2>
        <button className="p-3 mb-2 bg-black-0 hover:bg-black-20 focus:bg-black-40 border-2 border-black-600 rounded group relative">
          <img src={Export} alt="Export" />
          <div className="absolute top-12 left-1/2 -translate-x-1/2 mr-2 px-2 py-1 bg-gray-800 text-white text-xs shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10 whitespace-nowrap uppercase">
            Export
            <div className="absolute left-1/2 bottom-full border-4 border-transparent border-b-gray-800"></div>
          </div>
        </button>
      </div>

      {/* Tabs */}
      <div className="flex justify-center">
        <div className="flex gap-4 mb-4 bg-black-30 border-2 border-black-30 rounded-md items-center justify-center">
          {tabs.map(({ label, icon }) => (
            <button
              key={label}
              onClick={() => setActiveTab(label)}
              className={`flex items-center justify-center gap-2 pb-2 p-4 text-lg ${
                activeTab === label ? "bg-black-0 rounded-md" : ""
              }`}
            >
              <img src={icon} alt={label} className="w-6 h-6" />
              {label}
            </button>
          ))}
        </div>
      </div>

      {/* Description */}
      <p className="text-lg text-black-800 mb-2">
        Below, we present some of the most relevant posts today. You can filter
        by keyword, or search by keyword to find the top 10 trends on Linkedin.
      </p>

      {/* Filters */}
      <div className="space-y-4 mb-4">
        <div>
          <label className="block text-lg font-bold text-black-800 mb-1">
            Industry
          </label>
          <select className="w-full h-[42px] border border-black-600 rounded px-3 py-2 text-lg text-black-50 focus:outline-none cursor-pointer">
            <option>Select</option>
          </select>
        </div>
        <div>
          <label className="block text-lg font-bold text-black-800 mb-1">
            Keyword
          </label>
          <input
            type="text"
            placeholder="Write the keyword"
            className="w-full h-[42px] border border-black-600 rounded px-3 py-2 text-lg text-black-600 placeholder:text-black-50 focus:outline-none"
          />
        </div>
      </div>

      {/* Bubble Chart */}
      <Bubble data={data} options={options} />
    </div>
  );
};

export default TopPost;
